const altTexts = [
  'Imox Kitchen Equipment',
  'commercial kitchen equipment Dubai',
  'kitchen equipment UAE',
  'refurbished kitchen equipment',
  'commercial kitchen design',
  'kitchen equipment servicing',
  'catering equipment Dubai',
  'bakery equipment UAE',
  'hygiene products for kitchens',
  'kitchen equipment repairs',
  'UAE kitchen suppliers',
  'kitchen equipment trading',
  'Dubai kitchen installation',
  'kitchen supply UAE',
  'commercial catering equipmentkitchen equipment store',
  'kitchen equipment supplier',
  'restaurant equipment supplier in uae',
  'online kitchen equipment shop'
]
export default altTexts